// Section 4: seasonal modifiers on crops, forage, water and illness.
import { defineContributor } from '../../core/registry';
import { mod } from '../../core/modifiers';

export const seasonContributor = defineContributor({
  slot: 'season',
  id: 'season:core',
  targets: ['output', 'illnessRisk'],
  modifiers(ctx, target) {
    const s = ctx.season.season;
    const source = `season:${s}`;
    if (target.kind === 'illnessRisk') return [mod.mul(source, ctx.cfg.seasons.illness[s])];
    if (target.kind !== 'output') return [];
    switch (target.jobId) {
      case 'farmer':
        return [mod.mul(source, ctx.cfg.seasons.crops[s], 'crops')];
      case 'forager':
        return [mod.mul(source, ctx.cfg.seasons.forage[s], 'forage')];
      case 'water-carrier':
        return [mod.mul(source, ctx.cfg.seasons.water[s], 'water')];
      default:
        return [];
    }
  },
});
